/* src/app/builder-screen-beta/panel-preset-selector/panel-preset-selector.component.scss */
.panel-preset-selector {
  padding: 12px 16px;
  border-bottom: 1px solid #f0f0f0;
  background: #fafafa;
}
.panel-preset-selector.compact {
  padding: 8px 12px;
}
.panel-preset-selector .preset-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  color: #595959;
  font-size: 13px;
  font-weight: 500;
}
.panel-preset-selector .preset-header .preset-title {
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.panel-preset-selector .preset-cards-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-bottom: 16px;
  padding: 0;
}
.panel-preset-selector .preset-card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 12px;
  border: 2px solid #e5e7eb;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  background: #ffffff;
  padding: 16px 12px;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  min-height: 90px;
  -webkit-user-select: none;
  user-select: none;
}
.panel-preset-selector .preset-card.preset-button {
  outline: none;
  font-family: inherit;
  font-size: inherit;
}
.panel-preset-selector .preset-card.preset-button:focus {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}
.panel-preset-selector .preset-card.preset-button:active {
  transform: translateY(0);
}
.panel-preset-selector .preset-card:hover {
  background: #f9fafb;
  transform: translateY(-1px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-color: #d1d5db;
}
.panel-preset-selector .preset-card.selected {
  border-color: #3b82f6;
  background: #eff6ff;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
}
.panel-preset-selector .preset-card.selected .card-icon nz-icon {
  color: #3b82f6;
  transform: scale(1.1);
}
.panel-preset-selector .preset-card.selected .card-label {
  color: #1d4ed8;
  font-weight: 600;
}
.panel-preset-selector .preset-card .card-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  margin-bottom: 8px;
}
.panel-preset-selector .preset-card .card-icon nz-icon {
  font-size: 20px;
  color: #6b7280;
  transition: all 0.2s ease;
}
.panel-preset-selector .preset-card .card-label {
  font-size: 12px;
  font-weight: 500;
  color: #374151;
  text-align: center;
  line-height: 1.3;
  transition: all 0.2s ease;
  text-transform: capitalize;
}
.panel-preset-selector .preset-card .selection-indicator {
  position: absolute;
  top: 8px;
  right: 8px;
}
.panel-preset-selector .preset-card .selection-indicator nz-icon {
  font-size: 16px;
  color: #3b82f6;
  animation: checkmark 0.3s ease-in-out;
}
.panel-preset-selector .preset-card.instant-applied {
  animation: instantApplied 0.6s ease-out;
  transform: scale(1.02);
}
.panel-preset-selector .active-preset-info {
  padding: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  margin-top: 8px;
}
.panel-preset-selector .active-preset-info .info-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: #64748b;
  font-size: 12px;
}
.panel-preset-selector .active-preset-info .info-content nz-icon {
  color: #3b82f6;
  font-size: 14px;
}
.panel-preset-selector .active-preset-info .info-content strong {
  color: #1e293b;
  font-weight: 600;
}
.panel-preset-selector.compact .preset-header {
  margin-bottom: 8px;
  font-size: 12px;
}
.panel-preset-selector.compact .preset-buttons .preset-button {
  height: 28px;
  min-width: 32px;
}
.panel-preset-selector.compact .preset-buttons .preset-button .preset-name {
  display: none;
}
.panel-preset-selector.compact .preset-stats {
  display: none;
}
.panel-preset-selector.preset-applied {
  animation: presetApplied 1s ease-out;
  border-color: #52c41a;
  box-shadow: 0 0 10px rgba(82, 196, 26, 0.3);
}
@keyframes checkmark {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  50% {
    opacity: 1;
    transform: scale(1.2);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
@keyframes instantApplied {
  0% {
    transform: scale(1);
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 8px 25px rgba(34, 197, 94, 0.4);
    border-color: #22c55e;
  }
  100% {
    transform: scale(1.02);
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
    border-color: #3b82f6;
  }
}
@keyframes presetApplied {
  0% {
    transform: scale(1);
    background: #f8f9fa;
  }
  50% {
    transform: scale(1.02);
    background: #f6ffed;
    border-color: #52c41a;
  }
  100% {
    transform: scale(1);
    background: #f8f9fa;
  }
}
/*# sourceMappingURL=panel-preset-selector.component.css.map */
